<template>
  <div class="container-fluid">
    <div class="center">
      <span class="xz-title bold">{{ company.name }}</span><br/>
      <span>Org.nr. {{ company.vatNumber }} MVA</span><br/>
      <span class="xz-title"> Fra dato: {{ formatDate(fromDate) }}</span><br/>
      <span class="xz-title">Til dato: {{ formatDate(toDate) }}</span>
      <hr class="horizontal-dashed"/>
      <span class="xz-title bold">Transaksjoner</span>
    </div>
    <br/>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
  import moment from "moment/moment";

  export default {
    props: {
      fromDate: Date,
      toDate: Date,
      company: Object
    },
    methods: {
      formatDate(date) {
        return (moment(date)).format('DD.MM.YYYY');
      }
    }
  }
</script>
